import './discount-rule.scss';

import { uniq, indexOf, filter, without } from 'lodash';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { Barcodes } from '@pos/app/scripts/services/barcodes';
import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { DiscountRules } from '@shared/app/scripts/services/discount-rules';
import { DiscountRulesManager } from '@pos/app/scripts/services/discount-rules-manager';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { LocationManager } from '@shared/app/scripts/services/location-manager';
import { Mask } from '@core/app/scripts/services/mask';
import { Moment } from '@shared/app/scripts/vendor/moment';
import { Route } from '@pos/app/scripts/services/route';
import { Utility } from '@core/app/scripts/services/utility';

/*
 * Component responsible for /discount-rule route.
 */
angular
  .module('posApp')
  .directive(
    'discountRule',
    (
      barcodes: Barcodes,
      currentSession: CurrentSession,
      discountRules: DiscountRules,
      discountRulesManager: DiscountRulesManager,
      displayMessage: DisplayMessage,
      locationManager: LocationManager,
      mask: Mask,
      moment: Moment,
      navigateTo: NavigateTo,
      route: Route,
      translate: ng.translate.ITranslateService,
      utility: Utility,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./discount-rule.html').default,

      link: function ($scope) {
        const $translate = translate;

        $scope.param = route.param;

        $scope.shopsList = [];
        $scope.groupsList = [];
        $scope.collectionsList = [];
        $scope.brandsList = [];

        $scope.openItemList = false;
        $scope.listItems = [];
        $scope.availableItems = [];
        $scope.search = '';
        $scope.selectedDiscountRule = {
          articles: [],
          brands: [],
          collections: [],
          groups: [],
          shops: [],
        };

        if ($scope.param === 'add-new') {
          const model = {
            type: '',
            brands: [],
            collections: [],
            x: '',
            startTime: '',
            active: true,
            priority: 0,
            shops: [],
            version: { date: '20140710104913', v: 8 },
            groups: [],
            name: '',
            stopTime: '',
            y: '',
            articles: [],
          };

          model._id = currentSession.tenantId + '_' + utility.uuid();
          model.priority = 0;
          $scope.selectedDiscountRule = model;
        } else {
          displayMessage.showLoading();
          discountRules.get($scope.param).then((value) => {
            displayMessage.hideLoading();
            $scope.selectedDiscountRule = value;
            $scope.selectedDiscountRule.startTime = new Date(value.startTime);
            $scope.selectedDiscountRule.stopTime = new Date(value.stopTime);
          });
        }

        //Builds a list of all locations
        let shops = [];
        angular.forEach(locationManager.all, (value, id) => {
          if (value.name) {
            shops.push(value.name);
          }
        });
        shops = uniq(shops);
        $scope.shopsList = shops;

        const brands = [];
        let barcode = '';
        for (const i in barcodes.db) {
          barcode = barcodes.db[i];
          //brands list
          if (barcode.c && indexOf(brands, barcode.c) == -1) {
            brands.push(barcode.c);
          }
        }
        $scope.brandsList = brands;

        const collections = [];
        let barcode = '';
        for (const i in barcodes.db) {
          barcode = barcodes.db[i];

          //collections list
          if (barcode.t && indexOf(collections, barcode.t) == -1) {
            collections.push(barcode.t);
          }
        }
        $scope.collectionsList = collections;

        $scope.buildGroupsList = () => {
          const groups = [];
          let barcode = '';
          const selBrands = $scope.selectedDiscountRule.brands;
          for (const i in barcodes.db) {
            barcode = barcodes.db[i];
            //groups list
            if (
              barcode.e &&
              (!selBrands.length || indexOf(selBrands, barcode.c) != -1) &&
              indexOf(groups, barcode.e) == -1
            ) {
              groups.push(barcode.e);
            }
          }
          $scope.groupsList = groups;
        };

        const checkDiscountInput = () => {
          const x = $scope.selectedDiscountRule.x;
          const y = $scope.selectedDiscountRule.y;
          const positive = (value) => {
            if (isNaN(value)) {
              displayMessage.message($translate.instant('Value is NaN'));
              return false;
            }
            if (value < 0) {
              displayMessage.message($translate.instant('Value is negative'));
              return false;
            }
            return true;
          };
          const isInt = (value) => {
            const t = parseInt(value);
            if (t != value) {
              displayMessage.message($translate.instant('Value is fraction'));
              return false;
            }
            return true;
          };
          if (!positive(x)) {
            return false;
          }
          if (!positive(y)) {
            return false;
          }
          if (!isInt(x)) {
            return false;
          }
          if ($scope.selectedDiscountRule.type == 'x4y') {
            if (!isInt(y)) {
              return false;
            }
            if (y > x) {
              displayMessage.message(
                $translate.instant('Y should not be higher than X'),
              );
              return false;
            }
          } else if ($scope.selectedDiscountRule.type == 'x4ye') {
            //y==$ should already be the case, since isNaN and positive have been called
          } else {
            if (y > 100 || y < 1) {
              displayMessage.message($translate.instant('Y should be %'));
              return false;
            }
          }
          return true;
        };

        $scope.buildArticlesList = () => {
          // filter groups, brands, articles
          const articles = [];
          let barcode = '';
          const selBrands = $scope.selectedDiscountRule.brands;
          const selGroups = $scope.selectedDiscountRule.groups;
          for (const i in barcodes.db) {
            barcode = barcodes.db[i];
            //article list
            if (
              (barcode.a || barcode.b) &&
              (!selGroups.length || indexOf(selGroups, barcode.e) != -1) &&
              (!selBrands.length || indexOf(selBrands, barcode.c) != -1) &&
              indexOf(articles, barcode.a) == -1
            ) {
              articles.push(barcode.i);
            }
          }
          $scope.articlesList = articles;
        };

        $scope.cancelDiscountRule = () => {
          navigateTo('pos.route#discount-settings');
        };

        $scope.saveDiscountRule = (rule) => {
          // save discount rule
          if (
            $scope.discountRuleForm.$valid &&
            $scope.discountRuleForm.$dirty
          ) {
            // sort discount rules by priority
            angular.forEach(discountRulesManager.data, (discrule, indx) => {
              discrule.priority = indx;
            });
            if (checkDiscountInput()) {
              displayMessage.showLoading();
              rule.startTime = moment(rule.startTime).startOf('day').toDate();
              rule.stopTime = moment(rule.stopTime).endOf('day').toDate();

              discountRules.save(rule).then(() => {
                $scope.discountRuleForm.$setPristine();
                mask.hide();
                navigateTo('pos.route#discount-settings');
              });
            }
          }
        };

        $scope.editList = (list) => {
          if (list == 'articles') {
            if (
              $scope.selectedDiscountRule.brands.length === 0 &&
              $scope.selectedDiscountRule.groups.length === 0
            ) {
              displayMessage.message(
                $translate.instant('FirstChooseArticleOrGroup'),
              );
              return;
            }
          }

          displayMessage.showLoading();
          $scope.discountRuleForm.$dirty = true;
          $scope.search = '';

          if (list == 'groups') {
            $scope.buildGroupsList();
          } else if (list == 'articles') {
            $scope.buildArticlesList();
          }

          $scope.currentList = list;
          $scope.availableItems = angular.copy($scope[list + 'List']);
          $scope.listItems = $scope.selectedDiscountRule[list];
          mask.hide();
          $scope.toggleItemListPopup();
        };

        $scope.hasInvalidDates = (startTime, stopTime) => {
          if (!startTime || !stopTime) {
            return false;
          }

          if (new Date(startTime) > new Date(stopTime)) {
            return true;
          }

          return false;
        };

        $scope.filter = () => {
          const list = $scope.currentList;
          const filtered = filter($scope[list + 'List'], (val) => {
            let a = true;

            if ($scope.search) {
              a = val.toLowerCase().indexOf($scope.search.toLowerCase()) != -1;
            }

            return a;
          });
          $scope.availableItems = filtered;
        };

        $scope.addItemToList = (a) => {
          if (!$scope.selectedDiscountRule[$scope.currentList]) {
            $scope.selectedDiscountRule[$scope.currentList] = [];
          }
          $scope.selectedDiscountRule[$scope.currentList].push(a);
          //Ensure list items are unique SWUI-1140
          $scope.selectedDiscountRule[$scope.currentList] = uniq(
            $scope.selectedDiscountRule[$scope.currentList],
          );
        };

        $scope.removeItemFromList = (a) => {
          $scope.selectedDiscountRule[$scope.currentList] = without(
            $scope.selectedDiscountRule[$scope.currentList],
            a,
          );
        };

        $scope.toggleItemListPopup = () => {
          $scope.openItemList = $scope.openItemList ? false : true;
        };
      },
    }),
  );
